import React from 'react';

/**
 * Replaces image src when image src 404's
 * @param event
 * @param image_source
 */
// eslint-disable-next-line
export const setFallbackImage = (event: React.SyntheticEvent, image_source: string): void => {
  // @ts-ignore
  // eslint-disable-next-line
  event.currentTarget.onerror = null; // prevents looping

  // @ts-ignore
  // eslint-disable-next-line
  event.currentTarget.src = image_source;
};
